var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-text-editor-container"},[_c('b-field',{attrs:{"label":_vm.label}},[_vm._m(0)])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor textarea-like",domProps:{"innerHTML":_vm._s(_vm.value)}})
}]

export { render, staticRenderFns }